__turbopack_context__.v({
  "header": "header-module-scss-module__nFToxa__header",
  "isStepActive": "header-module-scss-module__nFToxa__isStepActive",
  "isStepCompleted": "header-module-scss-module__nFToxa__isStepCompleted",
  "step": "header-module-scss-module__nFToxa__step",
  "stepCheckIcon": "header-module-scss-module__nFToxa__stepCheckIcon",
  "stepCircle": "header-module-scss-module__nFToxa__stepCircle",
  "stepStripe": "header-module-scss-module__nFToxa__stepStripe",
  "stepTitle": "header-module-scss-module__nFToxa__stepTitle",
});
